export default "__VITE_ASSET__BdkTMmGr__"